import { render, staticRenderFns } from "./sidebarExchange.vue?vue&type=template&id=496e3890&"
import script from "./sidebarExchange.vue?vue&type=script&lang=js&"
export * from "./sidebarExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports